<template>
  <!--  서브페이지  -->
  <div id="sub_area">
    <!--비주얼 영역-->

    <div class="sub_visual">
      <div class="tit_area">
        <h2 class="tit">{{ title }}</h2>
      </div>
      <img v-if="title == '인재상'" :src="require('./../../assets/img/sub/sub04_1.png')" alt="BG" />
      <img v-if="title == '인사제도'" :src="require('./../../assets/img/sub/sub04_2.png')" alt="BG" />
      <img v-if="title == '인재채용'" :src="require('./../../assets/img/sub/sub04_3.png')" alt="BG" />
    </div>

    <div class="navigation_area">
      <div class="navigation">
        <router-link to="/" class="i_home">
          <span>HOME</span>
        </router-link>

        <div
          class="item"
          :class="{ on: mainMenuShow }"
          @mouseover="mainMenuShow = true"
          @mouseleave="mainMenuShow = false"
        >
          <a>{{ title }}</a>
          <div>
            <router-link
              active-class="on"
              tag="a"
              to="/Management/Talent"
              @click.native="mainMenuShow = false"
            >인재상</router-link>
            <router-link
              active-class="on"
              tag="a"
              to="/Management/Personnel"
              @click.native="mainMenuShow = false"
            >인사제도</router-link>
            <router-link
              active-class="on"
              tag="a"
              to="/Management/Recruitment"
              @click.native="mainMenuShow = false"
            >인재채용</router-link>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    mainMenuShow: false,
    message: "ManagementMain.vue",
    title: ""
  }),
  methods: {
    titleChange(urlPath) {
      switch (urlPath) {
        case "/Management/Talent":
          {
            this.title = "인재상";
          }
          break;
        case "/Management/Personnel":
          {
            this.title = "인사제도";
          }
          break;
        case "/Management/Recruitment":
          {
            this.title = "인재채용";
          }
          break;
      }
    }
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.titleChange(to.path);
    }
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
    this.titleChange(this.$route.path);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub04/ManagementMain.vue